export const HalteParentType = {
    parcours: "parcours",
    constellation: "constellation",
}

export function isValidHalteParentType(halteParentType){
    console.log("halteParentType test", halteParentType);
    if(!halteParentType){
        return false;
    }

    return HalteParentType.hasOwnProperty(halteParentType.toLowerCase());
}
